import { ERROR_MODAL_CLOSE } from '@redux/actions/types'
const initialState = {
  error: null,
  showErrorModal: false
}
const reducer = (state = initialState, action) => {
  const { error, type } = action
  if (error) {
    return {
      ...state,
      error,
      showErrorModal: true
    }
  }
  switch (type) {
  case ERROR_MODAL_CLOSE:
    return {
      ...state,
      error: null,
      showErrorModal: false
    }
  default:
    return state
  }
}
export default reducer
